import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import { Form } from 'react-form';
import _ from 'lodash';
import Dropzone from 'react-dropzone';
import Translate from 'translate';
import async from 'async';
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from 'html-to-draftjs';

import { FormGroup, Text, SelectCreatable, Wysiwyg, CheckboxGroup } from 'components/FormElements';
import { toggleLoading, toggleAlertError } from 'stores/actions';
import SearchContactsModal from 'routes/app/components/Agent/SearchContactsFilterModal/';

import { required, email } from "../../../../../constants/InputErrors";
import classNames from "classnames";
import ChannelService from "services/ChannelService";
import NetworkService from 'services/NetworkService'
import PreviewFileModal from 'routes/app/components/Agent/PreviewFileModal/';

import ChannelOperationService from "services/ChannelOperationService";
import IncmsService from "services/IncmsService";

class SendEmailModal extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      SearchContactsModalOpened: false,
      previewModalOpened: false,
      emails: [],
      emailBCCOptions: [],
      emailCCOptions: [],
      emailOptions: [],
      files: []
    };
    this.emailField= undefined;
    this.autoCompleteEmailBCC = this.autoCompleteEmailBCC.bind( this );
    this.autoCompleteEmailCC = this.autoCompleteEmailCC.bind( this );
    this.autoCompleteEmail = this.autoCompleteEmail.bind( this );
    this.emailKeyDown = this.emailKeyDown.bind(this);
    this.emailCCKeyDown = this.emailCCKeyDown.bind(this);
    this.emailBCCKeyDown = this.emailBCCKeyDown.bind(this);
    this.setEmail = this.setEmail.bind( this );
    this.setSubject = this.setSubject.bind( this );
    this.setContent = this.setContent.bind( this );
    this.togglePreviewModal = this.togglePreviewModal.bind( this );
    this.toggleSearchContactsModal = this.toggleSearchContactsModal.bind( this );

  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.open && !this.props.open ) {

      this.filesInitializated = false;

      this.setState( { files: [], 
        emailBCCOptions: [], 
        emailCCOptions: [], 
        contentField: this.props.content ? EditorState.createWithContent( ContentState.createFromText( this.props.content  ) ) : null,
      } );

      this.getData();
    }
      this.setState( { 
        contentField: this.props.content ? EditorState.createWithContent( ContentState.createFromBlockArray( htmlToDraft( this.props.content ).contentBlocks ) )  : null,
      } );
  }

  toggleSearchContactsModal = () => {
    
    this.setState( { SearchContactsModalOpened: !this.state.SearchContactsModalOpened } )
  }

  setCCEmail = ( email ) => {
    // console.log('email :>> ', email, this.emailField);
    if ( this.emailField === 'emailCC' ) {
      const emails = this.state.emailCc || [];
      emails.push( email );
      const formData = {
        ...this.state,
        emailCc: emails
      }
      this.setState( formData )
    } else if ( this.emailField === 'emailBCC' )  {
      const emails = this.state.emailBcc || [];
      emails.push( email );
      const formData = {
        ...this.state,
        emailBcc: emails
      }
      this.setState( formData )
    } else if ( this.emailField === 'email' )  {
      const emails = this.state.emailField || [];
      emails.push( email );
      const formData = {
        ...this.state,
        emailField: emails
     }
    this.setState( formData )
    }
    this.toggleSearchContactsModal();
  }

  closeContactList = ( email, emailField ) => {
    if (emailField ) {
      this.emailField = emailField;
      this.setCCEmail(email); 
    }
    this.toggleSearchContactsModal();
  }
  
  getData() {
    this.props.toggleLoading( true );

    async.parallel( {
      emails: this.getEmails,
      files: this.getAttachments
    }, ( error, results ) => {
      this.props.toggleLoading( false );

      let state = {};
      if( results.files && results.files.length ) {
        state.files = _.map( results.files, ( file ) => ( {
          id: file.id,
          label: <a target="_blank" href={file.path}>{file.name}</a>
        } ) );
      }
      if( results.emails && results.emails.data && results.emails.data.length ) {
        state.emails = _.filter( results.emails.data, item => !!item.email  );
      }
      state.emails = _.map(state.emails, (item) => ({ id: item.email, email: item.email } ) )
      // console.log(state.emails);
      this.setState( state );
      this.setState( { emailOptions: state.emails });
      
    } );
  }
  togglePreviewModal = ( file = {} ) => {
    this.filePreview = file;
    this.setState( { previewModalOpened: !this.state.previewModalOpened } )
  }
  setEmail = ( value ) => {
    this.setState( {emailField: value});
  }
  setContent = ( value ) => {
    this.setState({contentField: value});
    // console.log( value.getCurrentContent() );
    // EditorState.createWithContent( ContentState.createFromText( value ) 
    // this.setState( { contentField: EditorState.createWithContent( ContentState.createFromBlockArray(value.blocks) ) });
  }
  setSubject = ( value ) => {
    this.setState( {subject: value});
  }
  setEmailBcc = ( value ) => {
    this.setState( {emailBcc: value});
  }
  setEmailCc = ( value ) => {
    this.setState( {emailCc: value});
  }
  getAttachments = ( cb ) => {
    ChannelService.getChannelAttachments( this.props.channel.id )
      .then( response => cb( response.errors, response.data ) )
  };

  getEmails = ( cb ) => {
    if( !this.props.activeAccount || !this.props.activeAccount.account ) return cb( null, [] );
    IncmsService.getSendServices( this.props.activeAccount.account )
      .then( response => cb( null, response.data ) )
  };
  autoCompleteEmailBCC = ( value ) => {
    const {user} = this.props;
    if (value.length > 1) { 
      let emailBCCOptions = [];
      NetworkService.searchEmailContacts( user.id ).then( ( response ) => {
        if(response.errors){
          return toggleAlertError( response.errors );
        }
        else{
          emailBCCOptions = _.map( response.data.data, item  => (  { email: item.displayName, id: item.contactAddress } ));
          this.setState( {emailBCCOptions});
        }
      } )
    }
  }
  emailBCCKeyDown = (keyD) => {
    if (keyD.keyCode === 13) {
      this.setState( {emailBCCOptions:[...this.state.emailBCCOptions, {email:keyD.target.value, id:keyD.target.value}]})
    }
  }
  autoCompleteEmailCC = ( value ) => {
    const {user} = this.props;
    if (value.length > 1) { 
      let emailCCOptions = [];
      NetworkService.searchEmailContacts( user.id ).then( ( response ) => {
        if(response.errors){
          return toggleAlertError( response.errors );
        }
        else{
          emailCCOptions = _.map( response.data.data, item  => (  { email: item.displayName, id: item.contactAddress } ));
          this.setState( {emailCCOptions});
        }
      } )
    }
  }
  emailCCKeyDown = (keyD) => {
    if (keyD.keyCode === 13) {
      this.setState( {emailCCOptions:[...this.state.emailCCOptions, {email:keyD.target.value, id:keyD.target.value}]})
    }
  }

  autoCompleteEmail = ( value ) => {
    const {user} = this.props;
    if (value.length > 1) { 
      let emailOptions = [];
      NetworkService.searchEmailContacts( user.id ).then( ( response ) => {
        if(response.errors){
          return toggleAlertError( response.errors );
        }
        else{
          emailOptions = _.map( response.data.data, item  => (  { email: item.displayName, id: item.contactAddress } ));
          this.setState( {emailOptions: [...this.state.emails, ...emailOptions] });
        }
      } )
    }
  }

  emailKeyDown = (keyD) => {
    if (keyD.keyCode === 13) {
      this.setState( {emailOptions:[...this.state.emailOptions, {email:keyD.target.value, id:keyD.target.value}]})
    }
  }
  submitForm = ( data ) => {
    const dataToSend = {
      emailAddressTo: _.map( data.email, 'id' ).join( ';' ),
      emailCcTo: _.map( data.emailCc, 'id' ).join( ';' ),
      emailBccTo: _.map( data.emailBcc, 'id' ).join( ';' ),
      subject: data.subject,
      channel: this.props.channel.id,
      content: draftToHtml( convertToRaw( data.content.getCurrentContent() ) ),
    };
    if( data.files ) {
      dataToSend.files = _.map( data.files, 'id' )
    }
    this.props.toggleLoading( true );

    const reader = new FileReader();
    const attachments = [];
    async.eachSeries( this.state.attachments, ( file, nextFile ) => {
      reader.readAsDataURL( file );
      reader.onload = ( event ) => {
        attachments.push( {
          file: event.target.result,
          name: file.name
        } );
        nextFile()
      };
    }, ( error ) => {
      if( error ) return this.props.toggleAlertError( <Translate id="errorFileProcess"/> );
      ChannelOperationService.sendEmail( { ...dataToSend, attachments } )
        .then( ( response ) => {
          this.props.toggleLoading( false );
          if( response.errors ) return this.props.toggleAlertError( response.errors );

          this.props.toggleAlertError( <Translate id="messageSent"/> );
          this.props.onClose()
        } )
    } )
  };

  render() {
    const { content, onClose, open, channel, externalCustomer, user } = this.props;
    const { emailBCCOptions, emailCCOptions, emailCc, emailBcc, emailField, subject, contentField, emailOptions } = this.state;
    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-12 max-width-unset"
             open={open}
             onClose={onClose}>
        <Form onSubmit={this.submitForm}
              defaultValues={ {email:emailField, emailBcc: emailBcc, emailCc: emailCc, subject: subject, content: contentField }}
              validate={( values ) => {
                return {
                  email: required( values.email ) ? required( values.email ) : _.find( values.email, item => !!email( item.id ) ) ? 'There are no valid emails' : null,
                  subject: required( values.subject ),
                  emailCc: _.find( values.emailCc, item => !!email( item.id ) ) ? 'There are no valid emails' : null,
                  emailBcc: _.find( values.emailBcc, item => !!email( item.id ) ) ? 'There are no valid emails' : null,
                  content: values.content ? values.content.getCurrentContent().hasText() ? null : 'This field is required'
                    : 'This field is required',
                }
              }}>
          {( { getValue, removeValue, resetForm, setValue, submitForm } ) =>
            <form onSubmit={submitForm} className="mt-4">
              <h5 className="mt-0"><Translate id="sendEmail"/></h5>

              <div className="row mb-3">
                <div className="col-md-8">
                  <div className="row">
                    <FormGroup containerClass="col-md-6">
                      {externalCustomer !== 'kplc' &&
                      <label><Translate id="email"/></label>
                      }
                      {externalCustomer === 'kplc' &&
                      <label><Translate id="email"/> <span className="fa fa-list pointer" onClick={() => { this.emailField = 'email'; this.toggleSearchContactsModal() }}></span> </label> 
                      }

                      { ((externalCustomer !== 'kplc') || ( externalCustomer === 'kplc' &&  ( !user.emailUsername || user.emailUsername === '') )) &&
                        <SelectCreatable field="email" className="form-control" multi
                                    options={this.state.emails}
                                    onChange={this.setEmail}
                                    labelKey="email"/>
                      }
                      { (externalCustomer === 'kplc' && user.emailUsername && user.emailUsername !== '' ) &&
                        <SelectCreatable field="email" className="form-control" multi
                                    options={emailOptions}
                                    onChange={this.setEmail}
                                    noOptionsMessage={() => null}
                                    onInputChange={this.autoCompleteEmail}
                                    onInputKeyDown={this.emailKeyDown}
                                    labelKey="email"/>
                      }
                    </FormGroup>

                    <FormGroup containerClass="col-md-6">
                      <label><Translate id="subject"/></label>
                      <Text field="subject" 
                            className="form-control"
                            onChange={this.setSubject}
                      />
                    </FormGroup>
                  </div>

                  <div className="row">
                    <FormGroup containerClass="col-md-6">
                      {externalCustomer !== 'kplc' &&
                      <label>CC</label>
                      }
                      {externalCustomer === 'kplc' &&
                      <label>CC <span className="fa fa-list pointer" onClick={() => { this.emailField = 'emailCC'; this.toggleSearchContactsModal() }}></span> </label> 
                      }
                      { ((externalCustomer !== 'kplc') || ( externalCustomer === 'kplc' &&  ( !user.emailUsername || user.emailUsername === '') )) &&
                        <SelectCreatable field="emailCc" className="form-control" multi
                                      selectDisabled
                                      placeholder=""
                                      onChange={this.setEmailCc}
                                      labelKey="email"/>
                      }
                      { (externalCustomer === 'kplc' && user.emailUsername && user.emailUsername !== '' ) &&

                        <SelectCreatable field="emailCc" className="form-control" multi
                                      isMulti
                                      placeholder=""
                                      onChange={this.setEmailCc}
                                      onInputChange={this.autoCompleteEmailCC}
                                      onInputKeyDown={this.emailCCKeyDown}
                                      options={emailCCOptions}
                                      labelKey="email"/>
                      }

                    </FormGroup>

                    <FormGroup containerClass="col-md-6">
                      {externalCustomer !== 'kplc' &&
                      <label>BCC</label>
                      }
                      {externalCustomer === 'kplc' &&
                      <label>BCC <span className="fa fa-list pointer" onClick={() => { this.emailField = 'emailBCC'; this.toggleSearchContactsModal() }}></span> </label> 
                      }
                      { ((externalCustomer !== 'kplc') || ( externalCustomer === 'kplc' &&  ( !user.emailUsername || user.emailUsername === '') )) &&
                        <SelectCreatable field="emailBcc" className="form-control" multi
                                      selectDisabled
                                      placeholder=""
                                      onChange={this.setEmailBcc}
                                      labelKey="email"/>
                      }
                      { (externalCustomer === 'kplc' && user.emailUsername && user.emailUsername !== '' ) &&
                        <SelectCreatable field="emailBcc" className="form-control" multi
                                      isMulti
                                      placeholder=""
                                      onChange={this.setEmailBcc}
                                      onInputChange={this.autoCompleteEmailBCC}
                                      onInputKeyDown={this.emailBCCKeyDown}
                                      options={emailBCCOptions}
                                      labelKey="email"/>
                      }

                    </FormGroup>
                  </div>

                  <div className="row">
                    <FormGroup containerClass="col-md-12">
                      <label><Translate id="body"/></label>
                      <Wysiwyg field="content" onEditorStateChange={this.setContent} editorState={contentField}   />
                    </FormGroup>

                    <div className="col-md-12">
                      <Dropzone
                        className={classNames( 'btn btn-outline-secondary' )}
                        accept="application/pdf, .doc, .docx, .xls, .xlsx, image/*"
                        onDrop={( files ) => {
                          setValue( 'attachments', getValue( 'attachments' ) ? getValue( 'attachments' ).concat( ...files ) : files )
                          this.setState({attachments : this.state.attachments? this.state.attachments.concat( ...files ) : files})

                        }
                        }>
                        <i className="fa fa-paperclip"/>
                      </Dropzone>
                    </div>

                    <div className="col-md-12 send-email-new-files">
                      {_.map( this.state.attachments, ( file, index ) =>
                        <div key={index}
                             className="callout callout-info mx-0 my-2 p-2 d-flex justify-content-between">
                          <span className={'icon-link pointer color-purple'} onClick={() => this.togglePreviewModal( file ) }> {file.name} </span>
                          <i className="fa fa-close pointer"
                             onClick={() => { 
                               removeValue( 'attachments', index );
                               this.state.attachments.splice(index, 1);
                              }}/>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <h5 className="mt-0"><Translate id="attachments"/></h5>
                  <div className="send-email-files">
                    <CheckboxGroup className="border-secondary border-bottom py-1"
                                   field="files"
                                   labelPosition="right"
                                   options={this.state.files}
                                   labelStyle={{ zIndex: 3, margin: 0 }}
                    />
                  </div>
                  {!!this.state.files.length &&
                  <div className="text-right mt-2">
                    <button type="button" className="btn btn-outline-secondary"
                            onClick={() => setValue( 'files', [] )}>
                      Clear
                    </button>
                  </div>
                  }
                </div>
              </div>

              <hr/>
              <div className="text-right">
                <button className="btn btn-info text-uppercase">
                  <Translate id="send"/>
                </button>
              </div>
            </form>
          }
        </Form>
        <PreviewFileModal  data={this.filePreview}
        open={this.state.previewModalOpened}
        onClose={this.togglePreviewModal}
        />
        <SearchContactsModal 
        open={this.state.SearchContactsModalOpened}
        user={user}
        onClose={this.closeContactList}
        emailField={this.emailField}
        />
      </Modal>
    )
  }
}
const mapStateToProps = ( state, ownProps ) => ( {
  externalCustomer: state.settings.externalCustomer,
  user: state.user
} );

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( SendEmailModal );




// WEBPACK FOOTER //
// ./routes/app/components/Agent/SendEmailModal/index.js